"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = appendSDF;
const ensure_string_1 = require("ensure-string");
const sdf_parser_1 = require("sdf-parser");
async function appendSDF(moleculesDB, sdf, options = {}) {
    const { onStep } = options;
    sdf = (0, ensure_string_1.ensureString)(sdf);
    if (typeof sdf !== 'string') {
        throw new TypeError('sdf must be a string');
    }
    const parsed = (0, sdf_parser_1.parse)(sdf);
    moleculesDB.statistics = parsed.statistics;
    for (let i = 0; i < parsed.molecules.length; i++) {
        const molecule = parsed.molecules[i];
        moleculesDB.pushEntry(moleculesDB.OCL.Molecule.fromMolfile(molecule.molfile), molecule);
        if (onStep) {
            // eslint-disable-next-line no-await-in-loop
            await onStep(i + 1, parsed.molecules.length);
        }
    }
}
//# sourceMappingURL=appendSDF.js.map